import { Box, Card, CardContent, Typography } from "@mui/material";
import { FEATURES } from "../content";
import { PageContainer, SectionHeading, sectionSx } from "./SectionLayout";

function FeatureCard({ feature }) {
  const Icon = feature.icon;

  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        boxShadow: "0 12px 34px rgba(93, 63, 211, 0.06)",
        height: "100%",
        transition: "transform 180ms ease, box-shadow 180ms ease",
        "&:hover": {
          boxShadow: "0 20px 44px rgba(93, 63, 211, 0.11)",
          transform: "translateY(-4px)"
        }
      }}
    >
      <CardContent
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          p: 3.5,
          textAlign: "center",
          "&:last-child": { pb: 3.5 }
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            bgcolor: feature.background,
            borderRadius: "50%",
            color: feature.color,
            display: "flex",
            height: 58,
            justifyContent: "center",
            mb: 2.5,
            width: 58
          }}
        >
          <Icon sx={{ fontSize: 29 }} />
        </Box>
        <Typography component="h3" sx={{ fontSize: 17, fontWeight: 500 }}>
          {feature.title}
        </Typography>
        <Typography color="text.secondary" sx={{ fontSize: 13, lineHeight: 1.65, mt: 1.25 }}>
          {feature.description}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default function FeaturesSection() {
  return (
    <Box id="features" component="section" sx={sectionSx}>
      <PageContainer>
        <SectionHeading title="Powerful Features to Simplify Hiring" />
        <Box
          sx={{
            display: "grid",
            gap: 2.5,
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
              lg: "repeat(3, minmax(0, 1fr))"
            }
          }}
        >
          {FEATURES.map((feature) => (
            <FeatureCard key={feature.title} feature={feature} />
          ))}
        </Box>
      </PageContainer>
    </Box>
  );
}
